<template>
  <div v-if="filterForm">
    <a-card size="small" class="customer-filter" title="筛选条件">
      <a-form-model :label-col="labelCol" class="search-form" label-align="left">
        <a-row>
          <a-col :span="6">
            <a-form-model-item label="时间">
              <a-range-picker
                v-model="checkedDate"
                :default-value="checkedDate"
                :allow-clear="false"
                @change="onChange"
              />
            </a-form-model-item>
          </a-col>
          <a-col :span="6">
            <a-form-model-item label="团队">
              <a-select v-model="filterForm.team" style="width: 100%" allow-clear placeholder="团队" @change="onTeamChange">
                <a-select-option v-for="team in teams" :key="team.id" :value="team.name">{{ team.name }}
                </a-select-option>
              </a-select>
            </a-form-model-item>
          </a-col>
        </a-row>
      </a-form-model>
    </a-card>

    <a-row :gutter="16">
      <a v-for="ciData in ciDatas">
        <!-- <a-col class="customer-col" :span="8" @click="getDiagramDatas(ciData.project_name)"> -->
        <a-col class="customer-col" :span="8">
          <ci-charts
            v-if="ciDatas"
            ref="CiCharts"
            :filter-form="filterForm"
            :project_title="ciData.project_name"
            :success="ciData.success"
            :failed="ciData.failed"
          />
        </a-col>
      </a>
    </a-row>
  </div>
</template>
<script>
import moment from 'moment';
import VersionTaskFilter from '@/pages/data/components/VersionTaskFilter';
import CiCharts from '@/pages/data/cidiagram/components/CiCharts';
import { getCiData } from '@/api/data/quality';
import DataFilter from '@/pages/data/components/DataFilter';
import ProjectDefect from '@/pages/data/quality/components/ProjectDefect';
import { teamList } from '@/api/system/team';
export default {
  components: { VersionTaskFilter, CiCharts, DataFilter, ProjectDefect },
  props: {

  },
  data() {
    return {
      labelCol: { span: 5 },
      ciDatas: null,
      user_group: null,
      teams: [],
      checkedDate: [moment().subtract(1, 'month').add(1, 'day'), moment()],
      projects: null,
      filterForm: {
        start_date: null,
        end_date: null,
        user_group: null
      }
    };
  },
  computed: {
    filter() {
      const { checkedDate } = this;
      return {
        checkedDate
      };
    }
  },

  watch: {
    filter() {
      this.$emit('change', this.checkedDate, this.onTeamChange);
    }
  },
  created() {
    this.getDiagramDatas();
  },
  mounted() {
    this.getTeamList();
  },
  methods: {
    onTeamChange(value) {
      this.project_name = value;
      this.getDiagramDatas(this.project_name);
    },
    onChange(checkedDate) {
      this.filterForm = {
        start_date: checkedDate[0].format('YYYY-MM-DD'),
        end_date: checkedDate[1].format('YYYY-MM-DD')
      };
      this.getDiagramDatas(this.project_name);
    },
    onSearch() {
      this.$emit('change');
    },
    getTeamList() {
      teamList({}).then(res => {
        this.teams = res.data.items;
      });
    },
    getDiagramDatas(project_name) {
      this.project_name = project_name;
      this.ciDatas = null;
      getCiData({
        'begin_time': this.checkedDate[0].format('YYYY-MM-DD'),
        'end_time': this.checkedDate[1].format('YYYY-MM-DD'),
        'team': project_name
      }).then(res => {
        this.ciDatas = res.data;
      });
    }
  }
};
</script>
<style lang="less" scoped>
/deep/ .customer-filter {
  .ant-page-header {
    padding: 0;
  }
  margin-bottom: 16px;
  .ant-form-item {
    margin-bottom: 8px;
    display: flex;
    .ant-form-item-control-wrapper {
      flex: 1;
    }
  }
  .filter-right {
    float: right;
    text-align: right;
  }
}
.customer-col {
    margin-top: 16px;
}

</style>

